import * as Sentry from "@sentry/browser";
export var extractGameCode = function (originalStorefrontAccountCode) {
    return originalStorefrontAccountCode.split("-")[0];
};
export var extractPlatformCode = function (originalStorefrontAccountCode) {
    return originalStorefrontAccountCode.split("-")[2];
};
var checkMissingLocalization = function (intl, reversals) {
    var missingGames = [];
    var missingPlatforms = [];
    reversals.forEach(function (_a) {
        var originalStorefrontAccountCode = _a.originalStorefrontAccountCode;
        var gameCode = extractGameCode(originalStorefrontAccountCode);
        var platformCode = extractPlatformCode(originalStorefrontAccountCode);
        if (!Boolean(intl.messages["game-title-" + gameCode]) && !missingGames.includes(gameCode)) {
            missingGames.push(gameCode);
        }
        if (platformCode) {
            if (!Boolean(intl.messages["platform-title-" + platformCode]) && !missingPlatforms.includes(platformCode)) {
                missingPlatforms.push(platformCode);
            }
        }
    });
    return { missingGames: missingGames, missingPlatforms: missingPlatforms };
};
export var sendMissingLocalization = function (intl, reversals) {
    var _a = checkMissingLocalization(intl, reversals), missingGames = _a.missingGames, missingPlatforms = _a.missingPlatforms;
    if (missingGames.length > 0) {
        Sentry.captureException("The following game localizations are missing in rfs-web: " + missingGames.join());
    }
    if (missingPlatforms.length > 0) {
        Sentry.captureException("The following platform localizations are missing in rfs-web: " + missingPlatforms.join());
    }
};
//# sourceMappingURL=localizationHelper.js.map